<template>
    <el-dialog
      class="assign"
      :visible="isAssignShow"
      width="700px"
      :before-close="assignClose">
      <template slot="title">
        <div class="assign-title">布置错题巩固练习</div>
        <div></div>
      </template>
      <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="assign-rule">
        <el-form-item label="练习名称" prop="name" class="">
          <el-input
          v-model="practiceName"
          maxlength="30"
          class="assign-rule__input"
          ></el-input>
          <span> {{number}}/30</span>
        </el-form-item>
        <el-form-item>
          <span>练习题目数量： 共{{topicLength}}题</span>
        </el-form-item>
        <div v-if="exportShow">
          <el-form-item>
            <el-button
              type="primary"
              class="assign-rule__button"
              @click="handleExport">立即导出</el-button>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item>
            <img class="assign-rule__img" src="../images/checkbox.png" alt="">
            <span class="assign-rule__derive">导出成功, 链接已生成</span>
            <span class="assign-rule__bg"></span>
          </el-form-item>
          <el-form-item label="仅题目内容"  class="">
            <el-input
            v-model="NoAnswer"
            class="assign-rule__content"></el-input>
            <el-button size="medium" type="warning" @click="newPage(NoAnswer)">打开</el-button>
            <el-button size="medium" type="primary" @click="copy( NoAnswer)">
              复制</el-button>
          </el-form-item>
          <el-form-item label="含答案解析"  class="">
            <el-input id="answer" v-model="answer" class="assign-rule__content"></el-input>
            <el-button size="medium" type="warning" @click="newPage(answer)">打开</el-button>
            <el-button size="medium" type="primary" @click="copy( answer)">复制</el-button>
          </el-form-item>
        </div>
      </el-form>
      <el-input id="content" class="assign-ipt"></el-input>
</el-dialog>
</template>

<script>
import { createKnowledgeOrWrong, getShortUrl } from '@/api/pt';
import { debounce, openTab } from '@/utils';

export default {
  props: {
    isAssignShow: {
      type: Boolean,
      require: true,
    },
    topic: {
      type: Array,
      require: true,
    },
    row: {
      type: Object,
      require: true,
    },
    requestCondition: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      exportShow: true,
      practiceName: '', // 练习名称
      ruleForm: {
        name: '错题巩固练习',
      },
      createKnowledgeList: [],
      NoAnswer: '',
      answer: '',
      rules: {
        name: [
          { required: true, message: '请输入练习名称', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.timeShow();
  },
  watch: {
    requestCondition() {
      this.timeShow();
    },
  },
  computed: {
    number() {
      return this.practiceName.length;
    },
    topicLength() { // 题目数量
      return this.topic.length;
    },
  },
  mounted() {
  },
  methods: {
    assignClose() { // 关闭弹框
      if (!this.exportShow) {
        this.$emit('update:isAssignShow', false);
        this.$emit('clearchange');
        this.$emit('clearList', true);
        this.timeShow();
        this.exportShow = true;
        return;
      }
      this.$confirm('是否取消布置,取消后不会保留所选内容', {
        customClass: 'message-logout',
        confirmButtonText: '取消布置',
        cancelButtonText: '继续布置',
      })
        .then(() => {
          this.$emit('update:isAssignShow', false);
          this.$emit('clearList', false);
          this.timeShow();
          this.exportShow = true;
        })
        .catch(() => {});
    },
    timeShow() { // 练习名称加日期
      console.log('timeShow', this.requestCondition);
      const myDate = new Date();
      const mm = myDate.getMonth() + 1;
      const dd = myDate.getDate();
      const time = (mm < 10 ? `0${mm}` : `${mm}`) + (dd < 10 ? `0${dd}` : `${dd}`);
      if (this.requestCondition.isKnowledge) {
        this.practiceName = time + this.requestCondition.tag_name + this.ruleForm.name;
      } else if (Number(this.requestCondition.classType) === 2) {
        this.practiceName = time
        + this.requestCondition.subjectName + this.ruleForm.name;
      } else {
        this.practiceName = time
        + this.requestCondition.className
        + this.requestCondition.subjectName + this.ruleForm.name;
      }
    },
    handleExport() { // 立即导出
      if (this.ruleForm.name.trim() === '') {
        this.$message({
          message: '请保证练习名称不为空',
          type: 'worry',
        });
        return;
      }
      this.btg();
    },

    btg: debounce(function lx() {
      this.createKnowledgeOrWrong();
      setTimeout(() => {

      }, 500);
    }, 1000, true),
    createKnowledgeOrWrong() { // 创建错题
      const questionIds = [];
      this.topic.forEach((item) => {
        questionIds.push(item.question_uuid ? item.question_uuid
          : (item.questionId || item.question_title_uuid || item.question_id));
      });
      if (Number(this.requestCondition.classType) === 2) {
        this.createKnowledgeOne(this.requestCondition, questionIds);
      }
      if (Number(this.requestCondition.classType) === 1) {
        this.createKnowledgeOne(this.row, questionIds);
      }
    },
    async createKnowledgeOne(tagCode, questionIds) {
      try {
        const res = await createKnowledgeOrWrong({
          test_id: this.requestCondition.testId, // 测评课程
          test_name: this.requestCondition.testName, // 测评课程
          tag_code: tagCode && tagCode.tag_code, // 知识点code 兼容处理：班级报告不需要传
          class_id: this.requestCondition.classId, // 班级id
          exercise_name: this.practiceName, // 自命名的名称
          question_number: this.topicLength, // 题目数量
          type: Number(this.requestCondition.testType) === 4 ? 4 : 2, // 错题
          question_ids: JSON.stringify(questionIds),
        });
        if (res.code === 200) {
          this.createKnowledgeList = res.data;
          this.getShortUrl(`${window.location.origin}/pt/export-test?serialNum=${
            this.createKnowledgeList.serial_num}&teacherId=${
            this.createKnowledgeList.teacher_id}&showAnswer=0`, 0);
          this.getShortUrl(`${window.location.origin}/pt/export-test?serialNum=${
            this.createKnowledgeList.serial_num}&teacherId=${
            this.createKnowledgeList.teacher_id}&showAnswer=1`);
        } else {
          this.$toast('请稍后再试');
        }
      } catch (err) {
        console.log(err);
      }
    },
    getShortUrl(data, id) { // 长链生成短链
      getShortUrl({
        long_url: data,
      }).then((res) => {
        if (res.code === 200) {
          this.exportShow = false;
          if (id === 0) {
            this.NoAnswer = res.data.shortUrl;
            return;
          }
          this.answer = res.data.shortUrl;
        }
      }).catch(() => {
        this.exportShow = true;
      });
    },
    newPage(value) { // 打开新页面
      openTab(value);
    },
    copy(url) { // 复制
      const input = document.getElementById('content');
      input.value = url;
      input.select();
      document.execCommand('copy');
      this.$message({
        message: '复制链接成功',
        type: 'success',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#content {
      position: relative;
      top: 0px;
    }
  .assign {
    // position: relative;
    /deep/ .el-dialog {
      background: #FFFFFF;
      border-radius: 16px;
    .el-icon-close:before {
    content: "\e6db";
    position: relative;
    top: -12px;
    right: -10px;
    font-size: 20px;
}
    }
    &-ipt {
      position: absolute;
      top: -1000px;
      opacity: 0;
    }
    &-title {
      position: absolute;
      left: 50%;
      top: 28px;
      transform: translateX(-50%);
      font-size: 24px;
      font-family: 'PingFangSC-Medium', 'PingFang SC';
      font-weight: 500;
      color: #000000;
      line-height: 33px;
    }
    &-rule {
      margin-top: 40px;
      margin-bottom: 60px;
      padding-left: 29px;
      &__input {
        width: 300px;
      }
      &__content {
        width: 298px;
        margin-right: 20px;
      }
      &__button {
        position: absolute;
        width: 218px;
        left: 50%;
        transform: translateX(-50%);
      }
      &__img {
        vertical-align: text-bottom;
      }
      &__derive {
        margin-left: 12px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8)
      }
      &__bg {
        position: absolute;
        width: 166px;
        height: 12px;
        top: 15px;
        left: 27px;
        background: rgba(230, 162, 60, 0.2);
        border-radius: 7px;
      }
    }
  }
</style>

<style lang="scss">
  .message-logout {
    width: 400px;
    height: 150px;
    text-align: center;
    .el-message-box__btns {
      text-align: center;
      margin-top: 20px;
    }
  }
</style>
